module.exports = __webpack_public_path__ + "static/media/manTrBS.f63b9794.png";